import React, {useState, useEffect} from "react";

import {APP_URL, APP_NAME, API_ENDPOINT, addDays} from '../config/Common'
import Input from '../../ui/input.jsx'

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'
import Button from '../../ui/Button.tsx'
import {useAuth} from '../../provider/AuthProvider'
import SelectInput from '../../ui/select-input.jsx'
import Label from '../../ui/label.tsx'
import Radio from '../../ui/radio/radio.tsx';
import Checkbox from '../../ui/checkbox/checkbox.tsx'
import TextArea from '../../ui/text-area.tsx'
import DatepickerInput from '../../ui/datepicker-input.jsx'

import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import * as Yup from 'yup';
import {
   Control,
   FieldErrors,
   useForm,
   useFormState,
   useWatch,
   Controller
 } from 'react-hook-form';
 
import { yupResolver } from '@hookform/resolvers/yup';
import moment from 'moment';
import {PlainIcon} from '../../custom-icons'
import axios from 'axios';  

const FormSchema = Yup.object().shape({
   name: Yup.string()
      .required('You must need to provide your full name.')
      .min(2, 'Name is too short!')
      .max(50, 'Name is too long!'),
   phone_no: Yup.string()
      .required('You must need to provide your phone number.')
      .min(12, 'Invalid phone number.'),
   email: Yup.string()
      .required('You must need to provide your email address.')
      .email('Invalid email.'),
   other_info: Yup.string()
      .required('Tell us about Issues'),
   product_name: Yup.string()
      .required('Product Name is required.'),
   sku: Yup.string()
      .required('Sku is required.'),
});

let defaultValues = {  
   name: '',
   email:'',
   phone_no:'',
   agree:true
};

const ReportFraudForm = () => {

   const { isUser, myInfo } = useAuth();
   const [states, setStates] = useState(null);
   const [cities, setCities] = useState(false);
   const [category, setCategory] = useState(null)
   const [subCategory, setSubCategory] = useState(null)
   const [brands, setBrands] = useState(null)
   const [models, setModels] = useState(null)
   const [startDate, setStartDate] = useState(null);
   const [loading, setLoading] = useState(false)
   const [success, setSuccess] = useState(false)

   const { register, handleSubmit , control, reset, setValue, setError, formState: { errors },} = useForm({
      defaultValues: defaultValues,
      resolver: yupResolver(FormSchema),
   });

   useEffect(() => {
   
      defaultValues = {  
         name: myInfo ? myInfo.name : '',
         email:myInfo ? myInfo.email :'',
         phone_no:myInfo ? myInfo.phone_no.length < 12 ? `91${myInfo.phone_no}` : myInfo.phone_no : '',
         agree:true
      };

     
      reset(defaultValues)
   },[])

   useEffect(() => {
      console.log(myInfo)
      let date = addDays(new Date(), 1);
      setStartDate(date)
      setValue('appointment_date', moment(date).format(), true);

   },[])

   
   const onSubmit = (values) => {
      //console.log('Enquiry form======',values)
      setLoading(true)
      let input = values
      //'appointment_date', moment(date).format()
      input = {...input, 
         /* cat_id:values?.cat_id?.cat_id,
         sub_cat:values?.sub_cat?.cat_id,
         brand_id:values?.brand_id?.brand_id,
         model_id:values?.model_id?.model_id,
         state_id:values?.state_id?.id,
         city_id:values?.city_id?.id, */
      }
      console.log('Enquiry form======',input)

      axios.post(`${API_ENDPOINT}/send_fraud_report_form`,input,{
         headers: {
            'Content-Type': 'application/json',
         }
      }).then( (result)=> {
         console.log('data=====',result.data)
         setLoading(false)
         if(result.data.status === 1){
            setSuccess(true)
            window.scrollTo({
               top: 0,
               left: 0,
               behavior: "smooth"
             });
         }
         
      })
   }




   return(
      <div>
         <h1 className="mb-7 font-body text-xl font-bold text-heading md:text-2xl">
         Report Fraud         
         </h1>
         {
         success ?
         <p className="my-2 text-xl text-center text-green-500">
            Your fraud report has been submitted successfully.<br/>We will be get back to you soon.
         </p>
         :
         <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid grid-cols-1 gap-2 sm:gap-6 sm:grid-cols-2">
               <Input                
                  label={`Name`}
                  {...register('name')}
                  variant="outline"
                  className="mb-5"
                  error={errors.name?.message}
                  required
               />
               <Input                
                  label={`Email`}
                  {...register('email')}
                  variant="outline"
                  className="mb-5"
                  type="email"
                  error={errors.email?.message}
                  required
               />
            </div>
            <div className="grid grid-cols-1 gap-2 sm:gap-6 sm:grid-cols-2">
               <div className="mb-5">
                  <label htmlFor="phone_no" className="block mb-3 text-sm font-semibold leading-none text-body-dark">Phone number <span className="text-red-500">*</span></label>
                  <Controller
                     name="phone_no"
                     control={control}
                     render={({ field }) => (
                        <PhoneInput
                           country="in"
                           disableDropdown
                           countryCodeEditable={false}
                           inputClass="!p-0 ltr:!pr-4 rtl:!pl-4 ltr:!pl-14 rtl:!pr-14 !flex !items-center !w-full !appearance-none !transition !duration-300 !ease-in-out !text-heading !text-sm focus:!outline-none focus:!ring-0 !border !border-border-base !rounded focus:!border-accent !h-12"
                           dropdownClass="focus:!ring-0 !border !border-border-base !shadow-350"
                           {...field}
                        />
                     )}
                  />
                  <p className="my-2 text-xs text-start text-red-500">{errors.phone_no?.message}</p>
               </div>
            </div>   
            
            <h2 className="mb-7 font-body text-xl font-bold text-heading md:text-xl">
            About Product and Issue
            </h2>
            
            <div className="grid grid-cols-1 gap-2 sm:gap-6 sm:grid-cols-2">
               <Input
                  label='Product Name'
                  type="text"
                  {...register('product_name')}                        
                  variant="outline"
                  className="mb-5"
                  placeholder="" 
                  error={errors.product_name?.message}
                  required
               />
               <div className="mb-5">
                  <Input
                  label='Sku'
                  type="text"
                  {...register('sku')}                        
                  variant="outline"
                  className="mb-5"
                  placeholder="" 
                  error={errors.sku?.message}
               />
               </div>
            </div>   
            <TextArea
               label='Product Description'
               {...register('product_description')}                        
               variant="outline"
               className="mb-5"
               error={errors.product_description?.message}
               
            />
            <TextArea
               label='Issues/Other Info'
               {...register('other_info')}                        
               variant="outline"
               className="mb-5"
               error={errors.other_info?.message}
               required
            />
            
            <Button loading={loading}>
               Send <PlainIcon className="ml-2" />
            </Button>
         </form>
         }
      </div>
   )

}

export default ReportFraudForm